import SettingPage from './view/SettingPage.vue';

const routes = [
  {
    path: '/setting',
    name: 'setting',
    component: SettingPage,
    meta: {
      title: 'Profile',
      requiresAuth: true
    }
  }
];

export default routes;
